<panel width="600">
	<h1>{{ 'task-action.support-request' | translate }}</h1>
	<section>
		<div>
			<custom-select [placeholder]="'task-action.type-placeholder' | translate"
						   [selectList]="taskActionTypeList"
						   (valueChange)="changeTaskActionType($event)"
						   [required]="true"
						   [label]="'task-action.type' | translate" />
		</div>
		<div>
			<custom-select [placeholder]="'task-action.area-placeholder' | translate"
						   [selectList]="taskAreas"
						   [(value)]="taskAction.taskAreaId"
						   [label]="'task-action.area' | translate" />
		</div>

		<div>
			<custom-select [placeholder]="'task-action.owner-placeholder' | translate"
						   [selectList]="usersList"
						   [(value)]="taskAction.assignedToUserId"
						   [label]="'task-action.owner' | translate" />
		</div>
		<div>
			<date-input [label]="'task-action.deadline' | translate" [(value)]="taskflowDeadline" [minDate]="minDeadline" />
		</div>

		<custom-input [label]="'task-action.details' | translate"
					  [inputType]="inputTypeEnum.Editor"
					  [(value)]="taskAction.details"
					  [placeholder]="'task-action.details-placeholder' | translate"
					  [required]="true" />

		<custom-input [label]="'task-action.contact-on-complete' | translate"
					  [inputType]="inputTypeEnum.Switch"
					  [class]="taskAction.type == taskActionTypeEnum.contact ? 'disabled': ''"
					  [(value)]="contactOnComplete" />
	</section>
	<section>
		<file-upload [label]="'task-action.file-upload' | translate"
					 (busyChange)="uploading = $event"
					 [uploadedFiles]="uploadedFiles"
					 accept=".msg,.jpg,.pdf" />
	</section>
	<section class="row">
		<button #saveButton (click)="saveSupportflow()" [active]="!uploading">{{ 'general.save' | translate }}</button>
	</section>
</panel>
